import React, { useState } from 'react';
import assistantImage from '../assets/AI.png'; // Updated brain image
import NotifyPopup from '../common/NotifyPopup';

export default function SmartAssistant() {
  const [popupVisible, setPopupVisible] = useState(false);

  return (
    <>
      <div style={styles.wrapper}>
        <div style={styles.card}>
          <h1 style={styles.title}>Smart Assistant Coming Soon</h1>
          <p style={styles.subtitle}>
            We’re building an intelligent assistant to help you choose the best credit card—just for you.
          </p>
          <div style={styles.imageWrap}>
            <img src={assistantImage} alt="Smart Assistant" style={styles.image} />
          </div>
          <div style={styles.buttonWrap}>
            <button style={styles.notifyBtn} onClick={() => setPopupVisible(true)}>NOTIFY ME</button>
          </div>
        </div>
      </div>
      <NotifyPopup visible={popupVisible} onClose={() => setPopupVisible(false)} />
    </>
  );
}

const styles = {
  wrapper: {
    minHeight: '100vh',
    width: '100%',
    background: '#fff',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '2rem',
    boxSizing: 'border-box',
  },
  card: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    maxWidth: '720px',
    width: '100%',
    padding: '3rem 1rem',
  },
  title: {
    fontSize: '2rem',
    fontWeight: 700,
    color: '#000',
    fontFamily: '"Funnel Sans", sans-serif',
    marginBottom: '1rem',
  },
  subtitle: {
    fontSize: '1.1rem',
    color: '#444',
    fontWeight: 400,
    marginBottom: '2.2rem',
    lineHeight: 1.6,
    maxWidth: '600px',
  },
  imageWrap: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: '2rem',
  },
  image: {
    width: '100%',
    maxWidth: '420px', // Adjusted to match visual scale in reference
    height: 'auto',
  },
  buttonWrap: {
    display: 'flex',
    justifyContent: 'center',
  },
  notifyBtn: {
    backgroundColor: '#1E3FA6',
    color: '#fff',
    padding: '0.75rem 2rem',
    fontSize: '1rem',
    fontWeight: 600,
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
    letterSpacing: '0.5px',
  },
};
